import { esc } from "./format";
// 大会ページの「主催・問い合わせ先」の欄。主催者名、メール、ウェブサイトの順に出す。
// ウェブサイトは https の URL があるときだけリンクにし、別タブで開く（rel="noopener"）。形式が違う値は出さない
export interface ContactView { name: string; email?: string; url?: string }
export const safeContactUrl = (u: unknown): string => {
  if (typeof u !== "string") return "";
  const s = u.trim();
  if (!s || s.length > 200 || /[\s\u0000-\u001f\u007f"'<>\\`]/.test(s) || !/^https:\/\//i.test(s)) return "";
  try { const x = new URL(s); return x.protocol === "https:" && !x.username && !x.password ? s : ""; } catch { return ""; }
};
export function contactCellHtml(c: ContactView): string {
  const url = safeContactUrl(c.url);
  const label = url.replace(/^https:\/\//i, "").replace(/\/$/, "");
  return `${esc(c.name)}${c.email ? `<br><a href="mailto:${esc(c.email)}">${esc(c.email)}</a>` : ""}${url ? `<br><a href="${esc(url)}" target="_blank" rel="noopener">${esc(label)}</a>` : ""}`;
}
